import { Map } from 'immutable';
import { connect } from 'react-redux';
import { resetState } from "../../common/actions/General";
import { doFreshSearch, loadMoreResults } from "../../common/actions/Search";
import { doRetrieveData as retrieveDiscoverData } from "../actions/Discover";
import AddonDiscovery from "../components/AddonDiscovery";
import { SEARCH } from "../constants/perspectives";
function mapStateToProps(state) {
  const perspectives = state.get('perspectives');
  return {
    discover: perspectives.get('discover'),
    search: perspectives.get('search'),
    searchContainer: state.get('searchContainer')
  };
}
function mapDispatchToProps(dispatch, ownProps) {
  return {
    discoverActions: Map({
      retrieveDiscoverData(_ref) {
        let {
          filters,
          featureFlags
        } = _ref;
        dispatch(retrieveDiscoverData({
          algoliaClient: ownProps.algoliaClient,
          applyOverrides: ownProps.applyOverrides,
          environment: ownProps.environment,
          filters,
          resolveAlgoliaQueryFilterOverrides: ownProps.resolveAlgoliaQueryFilterOverrides,
          discoverCollectionsConfig: ownProps.discoverCollectionsConfig,
          featureFlags
        }));
      }
    }),
    searchActions: Map({
      doFreshSearch(_ref2) {
        let {
          filters,
          featureFlags
        } = _ref2;
        dispatch(doFreshSearch({
          algoliaClient: ownProps.algoliaClient,
          applyOverrides: ownProps.applyOverrides,
          environment: ownProps.environment,
          filters,
          resolveAlgoliaQueryFilterOverrides: ownProps.resolveAlgoliaQueryFilterOverrides,
          featureFlags
        }));
      }
    }),
    onLoadMoreResultsClick(_ref3) {
      let {
        currentPage,
        featureFlags
      } = _ref3;
      dispatch(loadMoreResults({
        algoliaClient: ownProps.algoliaClient,
        applyOverrides: ownProps.applyOverrides,
        environment: ownProps.environment,
        filters: ownProps.filters,
        nextPage: currentPage + 1,
        resolveAlgoliaQueryFilterOverrides: ownProps.resolveAlgoliaQueryFilterOverrides,
        featureFlags
      }));
    },
    onPerspectiveChange() {
      dispatch(resetState());
    },
    onHitCategoryClick(_ref4) {
      let {
        newFilters
      } = _ref4;
      ownProps.stateChangeRequested({
        perspective: SEARCH,
        filters: newFilters
      });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddonDiscovery);